<template>
  <section class="price-detail-wrap grey-bg">
    <div class="container">
      <div class="price-card-wrap">
        <PricingCard
          v-for="(item, index) in pricingDetail.pricingType"
          :item="item"
          :key="index"
          :extraClass="['no-list']"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { AthleteData } from "./data";
import PricingCard from "../pricing/price-card";

export default {
  name: "PriceDetail",
  components: {
    PricingCard
  },
  props: {
    pricingDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      AthleteData
    };
  }
};
</script>

<style lang="scss">
.price-detail-wrap {
  padding: 50px 0;
  .price-card-wrap {
    display: flex;
    justify-content: center;
    .price-card {
      margin-right: 50px;
      max-width: 400px;
      width: 100%;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .price-detail-wrap {
    padding: 35px 0;
    .price-card-wrap {
      flex-direction: column;
      .price-card {
        margin: 0 auto;
        &:last-child {
          margin: 30px auto 0;
        }
      }
    }
  }
}
</style>
